import { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Page404 } from "components";
import { Login, TermsAndConditions } from "pages/public";
import { withLoader } from "HOC";

const App = ({ setLoading }) => {
  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <>
      <Router>
        <Switch>
          <Route exact path="/identificate">
            <Login />
          </Route>
          <Route path="/legal">
            <TermsAndConditions />
          </Route>
          <Route path="*">
            <Page404 />
          </Route>
        </Switch>
      </Router>
    </>
  );
};

export default withLoader(App, "Cargando página");
